var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFormPreview = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 166,
  height: 110,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 165.6,
  height: 110,
  x: 0.2,
  fill: "#F4F4F4",
  rx: 3
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h66.24v36H0z",
  style: {
    mixBlendMode: "multiply"
  },
  transform: "translate(9.233 60)"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5E5",
  d: "M9.233 60h40v8h-40zM9.233 76h66.24v20H9.233z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h66.24v36H0z",
  style: {
    mixBlendMode: "multiply"
  },
  transform: "translate(90.527 60)"
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5E5",
  d: "M90.527 60h40v8h-40zM90.527 76h66.24v20h-66.24z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h147.535v36H0z",
  style: {
    mixBlendMode: "multiply"
  },
  transform: "translate(9.233 12)"
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5E5",
  d: "M9.233 12h40v8h-40zM9.233 28h147.535v20H9.233z"
})));
export default SvgFormPreview;